const progressBar = function($container) {
  const container = $container || $('body');
  const $progressBar = container.find($('@progressBar'));

  const moveProgressBar = function() {
    $.each($progressBar, function() {
      const $this = $(this);
      const $bar = $this.find($('@bar'));
      const $label = $this.prev($('@label'));
      const getPercent = ($this.data('progress-percent') / 100);
      const getProgressWrapWidth = $this.width();
      const progressTotal = getPercent * getProgressWrapWidth;
      const animationLength = 500;

      $bar.stop().animate({ left: progressTotal }, animationLength);
      $label.stop().addClass('progress_bar__picks_counter-leaderboard').animate({ left: progressTotal });
    });
  };

  $(window).on('click resize load', () => { moveProgressBar(); });

  moveProgressBar();
};

export default progressBar;

